import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6701cd4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-2" }, " Thank you! Please check back here when you receive a response ", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please let us know whether you were able to finish submitting your application via SSA.gov", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check mr-1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Yes, I submitted it ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times mr-1" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" No, please take me back to SSA.gov ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please let us know whether your application was approved", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check mr-1" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Yes, it was approved ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times mr-1" }, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" No, it was denied ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock mr-1" }, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" I'm still waiting ")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Would you like to try applying again?", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pen mr-1" }, null, -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Apply again ")
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pen mr-1" }, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Start Application ")
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "If you don't have a Social Security number at all, you can apply for one.", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "If you know your number, but don't have a card, you can order a replacement.", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "We will send you to the official SSA.gov site to complete the application.")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("If you have an existing account with "),
  /*#__PURE__*/_createElementVNode("strong", null, "ID.me"),
  /*#__PURE__*/_createTextVNode(", "),
  /*#__PURE__*/_createElementVNode("strong", null, "Login.gov"),
  /*#__PURE__*/_createTextVNode(", or "),
  /*#__PURE__*/_createElementVNode("strong", null, "SSA.gov"),
  /*#__PURE__*/_createTextVNode(", then we can speed up the application process.")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "If you don't have an existing account, you can still apply.", -1))
const _hoisted_38 = { class: "addressMessage mt-4 is-flex is-flex-direction-row full-width" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope mt-1 mr-2" }, null, -1))
const _hoisted_40 = { class: "full-width" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Please use this email when filling out the application:", -1))
const _hoisted_42 = {
  style: {"text-align":"center","font-size":"125%"},
  class: "mt-3 mb-1"
}
const _hoisted_43 = { class: "addressMessage mt-4 is-flex is-flex-direction-row full-width" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-pin mt-1 mr-2" }, null, -1))
const _hoisted_45 = { class: "full-width" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Please use this address when filling out the application:", -1))
const _hoisted_47 = {
  style: {"text-align":"center","font-size":"125%"},
  class: "mt-3 mb-3"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("u", null, "DO NOT"),
  /*#__PURE__*/_createTextVNode(" use this address for anything other than your Social Security application. Any other mail received here will not be delivered")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Please let us know whether you were able to complete your application.")
], -1))
const _hoisted_50 = { class: "addressMessage mt-4 is-flex is-flex-direction-row full-width" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope mt-1 mr-2" }, null, -1))
const _hoisted_52 = { class: "full-width" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Please use this email when filling out the application:", -1))
const _hoisted_54 = {
  style: {"text-align":"center","font-size":"125%"},
  class: "mt-3 mb-1"
}
const _hoisted_55 = { class: "addressMessage mt-4 is-flex is-flex-direction-row full-width" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-pin mt-1 mr-2" }, null, -1))
const _hoisted_57 = { class: "full-width" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Please use this address when filling out the application:", -1))
const _hoisted_59 = {
  style: {"text-align":"center","font-size":"125%"},
  class: "mt-3 mb-3"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("u", null, "DO NOT"),
  /*#__PURE__*/_createTextVNode(" use this address for anything other than your Social Security application. Any other mail received here will not be delivered")
], -1))

import { ApplicationStatus, ProfileTypes } from '@minicity/core';
import { computed, ref } from 'vue';
import { submitApplication, submitApplicationEvent, ApplicationEvent } from "@/features/applications/onlineSocialSecurity/api";
import { sessionState } from '@/core/session';
import { doApiAction } from '@/core/api';
import { CONFIG } from '@/core/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnlineSocialSecurityApplicationStatus',
  props: {
    application: null
  },
  emits: ['changed'],
  setup(__props: any, { emit }) {

const props = __props as {
  application?: ApplicationStatus.Report
}





const currentStatus = computed(() => {
  if (!props.application) return null;

  let status: ApplicationStatus.HistoryEntry|null = null;
  for (let entry of props.application.history) {
    if (entry.type != "FUTURE") { status = entry; }
  }
  return status;
});


const inProgressAction = ref<string|null>(null);

const createPhase = ref<"none"|"chooseType"|"chooseAuthMethod"|"awaitResponse"|"justSubmitted">("none");
const isForReplacementCard = ref<boolean>(false);
const hasExistingLogin = ref<boolean>(false);
const createdApplicationId = ref<string|null>(null);

const showApplicationTypePrompt = () => {
  createPhase.value = "chooseType";
}

const onApplicationTypeSelected = (replacement: boolean) => {
  isForReplacementCard.value = replacement;
  createPhase.value = "chooseAuthMethod";
}

const onAuthTypeSelected = (hasLogin: boolean) => {
  hasExistingLogin.value = hasLogin;
  
  window.open(hasLogin ? 'https://secure.ssa.gov/RIL/SiView.action' : 'https://secure.ssa.gov/ossnap/public/landingOSsnap', '_blank');

  if (props.application || createdApplicationId.value) {
    // Retrying an existing application
    submitEvent(ApplicationEvent.REAPPLY, true);
    createPhase.value = "awaitResponse";
  } else {
    // New application
    doApiAction(
      inProgressAction, "startApplication",
      null, null,
      () => submitApplication({
        citizenId: sessionState.session!.user.id,
        isForReplacementCard: isForReplacementCard.value,
        idempotencyToken: Math.random().toString(),
      })
      .then((id) => {
        createdApplicationId.value = id;
        createPhase.value = "awaitResponse";
      })
    );
  }
}

const onApplicationSubmitted = () => {
  submitEvent(ApplicationEvent.APPLICATION_SUBMITTED, true);
  createPhase.value = "justSubmitted";
}

const submitEvent = (event: ApplicationEvent, suppressChangedEvent?: boolean) => {
  doApiAction(
    inProgressAction, "submitEvent",
    null, null,
    () => submitApplicationEvent(
      props.application ? props.application.id : createdApplicationId.value!,
      event
    ).then(() => { if (!suppressChangedEvent) { emit('changed') } })
  );
}

return (_ctx: any,_cache: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (inProgressAction.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoadingSpinner, { size: "small" })
        ]))
      : (createPhase.value == 'justSubmitted')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : (__props.application)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_unref(currentStatus)?.statusId == 'NEW')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("button", {
                      class: "ctaButton m-2",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (submitEvent(_unref(ApplicationEvent).APPLICATION_SUBMITTED)))
                    }, _hoisted_10),
                    _createElementVNode("button", {
                      class: "ctaButton m-2",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {submitEvent(_unref(ApplicationEvent).APPLICATION_NOT_SUBMITTED, true); showApplicationTypePrompt();})
                    }, _hoisted_13)
                  ]))
                : (_unref(currentStatus)?.statusId == 'SUBMITTED')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("button", {
                        class: "ctaButton m-2",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (submitEvent(_unref(ApplicationEvent).APPLICATION_APPROVED)))
                      }, _hoisted_18),
                      _createElementVNode("button", {
                        class: "ctaButton m-2",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (submitEvent(_unref(ApplicationEvent).APPLICATION_REJECTED)))
                      }, _hoisted_21),
                      _createElementVNode("button", {
                        class: "ctaButton m-2",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (createPhase.value = 'justSubmitted'))
                      }, _hoisted_24)
                    ]))
                  : (_unref(currentStatus)?.statusId == 'REJECTED')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("button", {
                          class: "ctaButton m-2",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {submitEvent(_unref(ApplicationEvent).REAPPLY, true); showApplicationTypePrompt();})
                        }, _hoisted_29)
                      ]))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: "ctaButton startButton",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (createPhase.value='chooseType'))
            }, _hoisted_32)),
    (createPhase.value=='chooseType')
      ? (_openBlock(), _createBlock(_component_ModalDialog, {
          key: 4,
          active: true,
          class: "modal",
          title: "Social Security Application",
          severity: "info",
          allowClose: true,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (createPhase.value='none')),
          firstButtonText: "I need a new SS number",
          firstButtonSeverity: "info",
          onFirstbuttonselected: _cache[8] || (_cache[8] = ($event: any) => (onApplicationTypeSelected(false))),
          secondButtonText: "I just need a replacement card",
          secondButtonSeverity: "info",
          onSecondbuttonselected: _cache[9] || (_cache[9] = ($event: any) => (onApplicationTypeSelected(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_33,
            _hoisted_34,
            _hoisted_35
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (createPhase.value=='chooseAuthMethod')
      ? (_openBlock(), _createBlock(_component_ModalDialog, {
          key: 5,
          active: true,
          class: "modal",
          title: "Social Security Application",
          severity: "info",
          allowClose: true,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (createPhase.value='none')),
          firstButtonText: "I have an account",
          firstButtonSeverity: "info",
          onFirstbuttonselected: _cache[11] || (_cache[11] = ($event: any) => (onAuthTypeSelected(true))),
          secondButtonText: "I do not have an account",
          secondButtonSeverity: "info",
          onSecondbuttonselected: _cache[12] || (_cache[12] = ($event: any) => (onAuthTypeSelected(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_36,
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("p", _hoisted_42, _toDisplayString(`hello+${_unref(sessionState).session!.user.id}@minicityatl.com`), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("p", _hoisted_47, _toDisplayString(_unref(ProfileTypes).formatUSAddressShort(_unref(CONFIG)?.networkMailingAddress)), 1),
                _hoisted_48
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (createPhase.value=='awaitResponse')
      ? (_openBlock(), _createBlock(_component_ModalDialog, {
          key: 6,
          active: true,
          class: "modal",
          title: "Social Security Application",
          severity: "info",
          firstButtonText: "I completed the application",
          firstButtonSeverity: "info",
          onFirstbuttonselected: _cache[13] || (_cache[13] = ($event: any) => (onApplicationSubmitted())),
          secondButtonText: "I wasn't able to finish",
          secondButtonSeverity: "info",
          onSecondbuttonselected: _cache[14] || (_cache[14] = ($event: any) => (submitEvent(_unref(ApplicationEvent).APPLICATION_NOT_SUBMITTED)))
        }, {
          default: _withCtx(() => [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("p", _hoisted_54, _toDisplayString(`hello+${_unref(sessionState).session!.user.id}@minicityatl.com`), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("p", _hoisted_59, _toDisplayString(_unref(ProfileTypes).formatUSAddressShort(_unref(CONFIG)?.networkMailingAddress)), 1),
                _hoisted_60
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})